const courses = [
    {
        name: 'westover',
        displayName: 'Westover Golf Course',
        phone: '4135478610',
    },
    {
        name: 'ledges',
        displayName: 'Ledges Golf Club',
        phone: '4135322307',
    },
    {
        name: 'quaboag',
        displayName: 'Quaboag Country Club',
        phone: '4132675294',
    },
    {
        name: 'chicopee',
        displayName: 'Chicopee Country Club',
        phone: '4135949295',
    },
    {
        name: 'franconia',
        displayName: 'Franconia Golf Course',
        phone: '4137876467',
    },
    {
        name: 'veterans',
        displayName: 'Veterans Memorial Golf Course',
        phone: '4137876449',
    },
    {
        name: 'cold-spring',
        displayName: 'Cold Spring Country Course',
        phone: '4133234888',
    },
    {
        name: 'agawam',
        displayName: 'Agawam Municipal Golf Course',
        phone: '4137862194',
    },
    {
        name: 'green-hills',
        displayName: 'Green Hills Golf Course',
        phone: '5087991359',
    }
];

export default courses;
